<template>
  <div>
    <ProductDetail type="new" :submitting="submitting" @submit="submit" />
  </div>
</template>

<script>
import ProductDetail from '@/views/pages/products/ProductDetail.vue';
import useService from '@/auth/service/useService';

export default {
  components: {
    ProductDetail
  },

  data() {
    return {
      submitting: false
    };
  },

  methods: {
    submit(data) {
      const requestData = {
        description: data.description,
        gtip_id: data.gtip,
        currency_id: data.currency_code.value,
        origin_id: data.origin.value,
        merchant_product_id: data.merchant_product_id || null,
        manufacturer_product_id: data.manufacturer_product_id || null,
        standard_product_id: data.standard_product_id || null
      };

      this.submitting = true;
      useService
        .createProduct(requestData)
        .then(response => {
          this.$router.push('/products');
          this.showSuccessMessage(
            `${
              response.message ||
              (this.type === 'new'
                ? this.$t('Create Product Success Message')
                : this.$t('Edit Product Success Message'))
            }`
          );
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
